import { defineStore } from "pinia";
import { ref } from "vue";
import { ICrumb } from "@/utils/breadcrumb.ts";

interface IUIPreferences {
    collapseMenu: boolean;
    showAgentTranscript: boolean;
}

export const useUIStore = defineStore("ui-store", () => {
    const breadcrumbs = ref<ICrumb[]>([]);
    const preferences = ref<IUIPreferences>({
        collapseMenu: false,
        showAgentTranscript: true,
    });

    function setPreference(preference: IUIPreferences): void {
        preferences.value = {
            ...preferences.value,
            ...preference,
        };
    }

    function setBreadcrumbs(crumbs: ICrumb[]): void {
        breadcrumbs.value = crumbs;
    }

    return {
        breadcrumbs,
        setBreadcrumbs,
        preferences,
        setPreference,
    }
}, {
    persist: {
        storage: localStorage,
        paths: ['preferences'],
    }
});
